<template>
  <div class="sidebarUser">
    <div class="sidebar shadow">
      <div class="logo-details">
        <img src="../../assets/logos/icon-logo.png" class="icon" alt="" />
        <!-- <i class='bx bxl-c-plus-plus icon'></i> -->
        <div class="logo_name">
          <img src="../../assets/logos/LOGO_UBRUlib.png" class="icon" alt="" />
        </div>
        <i class="bx bx-menu" id="btn"></i>
      </div>
      <ul class="nav-list">
        <!-- <li>
            <i class='bx bx-search' ></i>
           <input type="text" placeholder="Search...">
           <span class="tooltip">Search</span>
        </li> -->
        <li>
          <router-link to="/" class="" active-class="active" exact>
            <i class="bx bx-home-smile"></i>
            <span class="links_name">หน้าหลัก</span>
          </router-link>
          <span class="tooltip">หน้าหลัก</span>
        </li>
        <li>
          <router-link to="/booking" class="" active-class="active" exact>
            <i class="bx bx-book-heart"></i>
            <span class="links_name">จองหนังสือ</span>
          </router-link>
          <span class="tooltip">จองหนังสือ</span>
        </li>
        <li>
          <router-link to="/bookingroom" class="" active-class="active" exact>
            <i class="bx bx-door-open"></i>
            <span class="links_name">จองห้อง</span>
          </router-link>
          <span class="tooltip">จองห้อง</span>
        </li>
        <li v-if="chk_auth">
          <router-link
            to="/checkOrder"
            class="nav__link"
            active-class="active"
            exact
          >
            <i class="bx bx-list-ul"></i>
            <span class="badge badge-purple-jong">
              <!-- {{
                setorders.length +
                +(setorders.length > 1 || setorders.length === 0 ? " " : "")
              }} -->
                {{ setorders.length }}{{ setorders.length > 1 || setorders.length === 0 ? " " : "" }}
<!-- {{ setorders.length }}{{ (setorders.length > 1 || setorders.length === 0) ? ' ' : '' }} -->

            </span>
            <span class="links_name">รายการจอง </span>
          </router-link>

          <span class="tooltip">รายการจอง</span>
        </li>
        <li v-if="chk_auth">
          <router-link
            to="/renew"
            class="nav__link"
            active-class="active"
            exact
          >
            <i class="bx bx-reset"></i>
            <span class="links_name">renew</span>
          </router-link>

          <span class="tooltip">renew</span>
        </li>

        <li>
          <a
            href="https://elibrary-ubru.cu-elibrary.com"
            target="_blank"
            class=""
          >
            <i class="bx bx-book-content"></i>
            <span class="links_name">E-book</span>
          </a>
          <span class="tooltip">E-book</span>
        </li>
       
        <li v-if="chk_auth">
          <router-link to="/profile" class="" active-class="active" exact>
            <i class="bx bx-user-circle"></i>
            <span class="links_name">โปรไฟล์</span>
          </router-link>
          <span class="tooltip">โปรไฟล์</span>
        </li>
        <li v-if="staff">
          <router-link to="/staff" class="" active-class="active" exact>
            <i class='bx bx-message-square-edit' ></i>
            <span class="links_name">Staff</span>
          </router-link>
          <span class="tooltip">Staff</span>
        </li>
        <li>
          <router-link to="/about" class="nav__link" active-class="active" exact>
            <i class="fa-solid fa-gears"></i>
            <span class="links_name">เกี่ยวกับ</span>
          </router-link>
          <span class="tooltip">เกี่ยวกับ</span>
        </li>
        <!-- <li>
          <a href="#">
            <i class="bx bx-heart"></i>
            <span class="links_name">Saved</span>
          </a>
          <span class="tooltip">Saved</span>
        </li>
        <li>
          <a href="#">
            <i class="bx bx-cog"></i>
            <span class="links_name">Setting</span>
          </a>
          <span class="tooltip">Setting</span>
        </li> -->
        <li class="profile" v-if="chk_auth" @click="logout()">
          <div class="profile-details">
            <img src="../../assets/icons/742751.png" alt="profileImg" />
            <div class="name_job text-left">
              <div class="name">{{ std_name }}</div>
              <div class="job">{{ std_code }}</div>
            </div>
          </div>
          <i class="bx bx-log-out" id="log_out"></i>
        </li>
        <li class="profile" v-if="!chk_auth" @click="login()">
          <div class="profile-details">
            <img src="../../assets/icons/742751.png" alt="profileImg" />
            <div class="name_job text-left">
              <div class="name">เข้าสู่ระบบ</div>
              <!-- <div class="job">{{ std_code }}</div> -->
            </div>
          </div>
          <i class="bx bx-log-in" id="login"></i>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
import axios from "axios";
export default {
  name: "Sidebar",
  props: ["setorders"],
  data() {
    return {
      std_name: "",
      std_code: "",
      loggedIn: false,
      qty: [],
      filteredArr: [],
      showCart: false,
      verified: false,
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      orders: [],
      auth: [],
      status_login: false,
      staff: false,
      data_booking: [],
      chk_qty: [],
      length_booking: 0,
      chk_auth: false,
    };
  },
  mounted() {
   
    if (localStorage.getItem("auth") != null) {
      this.chk_auth = true;
      this.auth = JSON.parse(localStorage.getItem("auth"));
      this.std_name = this.auth.std_name;
      this.std_code = this.auth.std_code;
      this.code = this.auth.std_code;
      if (localStorage.getItem("maxchk") == null) {
        this.qty_borrow_max_chk = this.auth.qty_borrow_max;
        localStorage.setItem("maxchk", this.auth.qty_borrow_max);
      }
      if (this.auth.isLibraryStaff === 1) {
        this.staff = true;
      } else {
        this.staff = false;
      }
    }

    if (localStorage.getItem("login") === null) {
      this.status_login = false;
      localStorage.setItem("login", this.status_login);
    } else {
      this.status_login = true;
      localStorage.setItem("login", this.status_login);
    }

    if (localStorage.getItem("booking") != null) {
      this.data_booking = JSON.parse(localStorage.getItem("booking"));

      // this.chkMaxBorrow()
    }
    let bb = JSON.parse(localStorage.getItem("booking"));
   
    if (bb !== null || bb !== '') {
      this.length_booking = 0;
      localStorage.setItem("chkqty", this.length_booking);
    }
    if (localStorage.getItem("orders") != null) {
      this.orders = JSON.parse(localStorage.getItem("orders"));
    }

    this.status();
    
    // // -------- toggle sub menus --------
    // let sidebar = document.querySelector(".sidebar");
    // let closeBtn = document.querySelector("#btn");
    // // let searchBtn = document.querySelector(".bx-search");

    // closeBtn.addEventListener("click", () => {
    //   sidebar.classList.toggle("open");
    //   menuBtnChange(); //calling the function(optional) 
    // });

    // // searchBtn.addEventListener("click", () => {
    // //   // Sidebar open when you click on the search iocn
    // //   sidebar.classList.toggle("open");
    // //   menuBtnChange(); //calling the function(optional)
    // // });

    // // following are the code to change sidebar button(optional)
    // function menuBtnChange() {
    //   if (sidebar.classList.contains("open")) {
    //     closeBtn.classList.replace("bx-menu", "bx-menu-alt-right"); //replacing the iocns class
    //   } else {
    //     closeBtn.classList.replace("bx-menu-alt-right", "bx-menu"); //replacing the iocns class
    //   }
    // }
  },
  methods: {
    removeFromCart(item) {
      if (this.booking.length === 0) {
        this.length_booking = 0;
        localStorage.setItem("chkqty", this.length_booking);
      } else {
        this.length_booking = localStorage.getItem("chkqty");

        this.length_booking -= item.qty_booking;
        localStorage.setItem("chkqty", this.length_booking);
      }

      item.qty_booking = 0; //fillter
      this.booking.splice(this.booking.indexOf(item), 1);
      localStorage.setItem("booking", JSON.stringify(this.booking));
    },
    sendItem(items) {
      let IP = localStorage.getItem("IP");

      let data = {
        token: this.token,
        books: items,
        std_code: this.code,
        staff_code: "",
        public_ip: IP,
      };

      const headers = {
        "content-type": "application/json",
      };
      // this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/datas", data, {
          headers,
        })
        .then((res) => {
          if (res.data.msg.status != 200) {
            alert(res.data.msg.message);
          } else {
            let order = res.data.Orders;
            this.orders = res.data.Orders;
            if (order === null) {
              localStorage.setItem("orders", "null");
            } else {
              localStorage.setItem("orders", JSON.stringify(order));
            }
            this.booking = [];
            localStorage.setItem("booking", JSON.stringify(this.booking));
            localStorage.setItem("chkqty", JSON.stringify(this.chkqty));
            // this.$isLoading(false);
            this.$router.push("checkOrder");
          }
        });
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.chk_auth = false;
        localStorage.removeItem("orders");
        this.$router.push("/");
      });
    },
    login() {
      this.$router.push("/login");
    },
    status() {
      if (!localStorage.getItem("access_token")) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* Google Font Link */
/* noti */
.badge-purple-jong {
  background-color: var(--bade-orange);
  color: white;
  position: absolute;
  top: 2px;
  left: 27px;
  width: 15px;
  height: 15px;
  /* display: flex; */
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 11px;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 78px;
  background: var(--bg-color);
  padding: 6px 14px;
  z-index: 99;
  transition: all 0.5s ease;
}
.sidebar.open {
  width: 250px;
}
.sidebar .logo-details {
  height: 60px;
  display: flex;
  align-items: center;
  position: relative;
}
.sidebar .logo-details .icon {
  opacity: 0;
  transition: all 0.5s ease;
}
.sidebar .logo-details .logo_name {
  color: var(--orange-color);
  font-size: 20px;
  font-weight: 600;
  opacity: 0;
  transition: all 0.5s ease;
}
.sidebar.open .logo-details .icon,
.sidebar.open .logo-details .logo_name {
  opacity: 1;
}
.sidebar .logo-details #btn {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  font-size: 22px;
  transition: all 0.4s ease;
  font-size: 23px;
  text-align: center;
  cursor: pointer;
  transition: all 0.5s ease;
}
.sidebar.open .logo-details #btn {
  text-align: right;
}
.logo-details img {
  width: auto;
  height: 50px;
}
.sidebar i {
  color: var(--orange-color);
  height: 60px;
  min-width: 50px;
  font-size: 28px;
  text-align: center;
  line-height: 60px;
}
.sidebar .nav-list {
  margin-top: 20px;
  height: 100%;
}
.sidebar li {
  position: relative;
  margin: 8px 0;
  list-style: none;
}
.sidebar li .tooltip {
  position: absolute;
  top: -20px;
  left: calc(100% + 15px);
  z-index: 3;
  background: var(--orange-color);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 400;
  opacity: 0;
  white-space: nowrap;
  pointer-events: none;
  transition: 0s;
  color: aliceblue;
}
.sidebar li:hover .tooltip {
  opacity: 1;
  pointer-events: auto;
  transition: all 0.4s ease;
  top: 50%;
  transform: translateY(-50%);
}
.sidebar.open li .tooltip {
  display: none;
}
.sidebar input {
  font-size: 15px;
  color: var(--orange-color);
  font-weight: 400;
  outline: none;
  height: 50px;
  width: 100%;
  width: 50px;
  border: none;
  border-radius: 12px;
  transition: all 0.5s ease;
  background: var(--first-color);
}
.sidebar.open input {
  padding: 0 20px 0 50px;
  width: 100%;
}
.sidebar .bx-search {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  font-size: 22px;
  background: var(--first-color);
  color: var(--orange-color);
}
.sidebar.open .bx-search:hover {
  background: var(--first-color);
  color: var(--orange-color);
}
.sidebar .bx-search:hover {
  background: var(--orange-color);
  color: var(--bg-color);
}
.sidebar li a {
  display: flex;
  height: 100%;
  width: 100%;
  border-radius: 12px;
  align-items: center;
  text-decoration: none;
  transition: all 0.4s ease;
  background: var(--bg-color);
}

.active {
  background: var(--orange-color) !important;
  color: var(--white) !important;
}
.active i {
  background: var(--orange-color) !important;
  color: var(--white) !important;
}
.active .links_name {
  background: var(--orange-color) !important;
  color: var(--white) !important;
}
.sidebar li a:hover {
  background: var(--orange-color);
}
.sidebar li a .links_name {
  color: var(--orange-color);
  font-size: 15px;
  font-weight: bold;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: 0.4s;
}
.sidebar.open li a .links_name {
  opacity: 1;
  pointer-events: auto;
}
.sidebar li a:hover .links_name,
.sidebar li a:hover i {
  transition: all 0.5s ease;
  color: var(--bg-color);
}
.sidebar li i {
  height: 50px;
  line-height: 50px;
  font-size: 22px;
  border-radius: 12px;
}
.sidebar li.profile {
  position: fixed;
  height: 60px;
  width: 78px;
  left: 0;
  bottom: -8px;
  padding: 10px 14px;
  background: var(--first-color);
  transition: all 0.5s ease;
  overflow: hidden;
}
.sidebar.open li.profile {
  width: 250px;
}
.sidebar li .profile-details {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}
.profile-details img {
  border-radius: 50%;
}
.sidebar li img {
  height: 45px;
  width: 45px;
  object-fit: cover;
  border-radius: 6px;
  margin-right: 10px;
}
.sidebar li.profile .name,
.sidebar li.profile .job {
  font-size: 15px;
  font-weight: 400;
  color: var(--white);
  white-space: nowrap;
}
.sidebar li.profile .job {
  font-size: 12px;
}
.sidebar .profile #log_out {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  background: var(--first-color);
  width: 100%;
  height: 60px;
  line-height: 60px;
  border-radius: 0px;
  transition: all 0.5s ease;
  color: var(--white);
}
.sidebar.open .profile #log_out {
  width: 50px;
  background: none;
}

.sidebar .profile #login {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  background: var(--first-color);
  width: 100%;
  height: 60px;
  line-height: 60px;
  border-radius: 0px;
  transition: all 0.5s ease;
  color: var(--white);
}
.sidebar.open .profile #login {
  width: 50px;
  background: none;
}

@media (max-width: 420px) {
  .sidebar li .tooltip {
    display: none;
  }
}
</style>
